import { TCGValueProp } from "./value-prop.component.js";
import "lit";
import "../../base/value-prop/value-prop.js";
import "lit/decorators.js";
import "../../components/leaf-element.js";
import "../../utilities/events.js";
import "../../utilities/slot.js";
import "../../components/icon/icon.js";
import "../../components/icon/icon.component.js";
import "lit/directives/unsafe-svg.js";
import "../../utilities/cache-fetch.js";
import "../../utilities/watch.js";
import "../../components/icon/library.js";
import "../../components/icon/iconset.system.js";
customElements.define("tcg-value-prop", TCGValueProp);
export {
  TCGValueProp
};
//# sourceMappingURL=value-prop.js.map
